export default `
  query calculateTax($input: CalculateTaxInput!) {
    calculateTax(input: $input) {
      success
      message
      data {
        amountTotal
        taxAmount
        taxRate
      }
    }
  }
`
